import React from 'react';
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import style from './FirstStep.module.scss';
import {Container, Row, Col} from "react-bootstrap";
import Select from "react-select";
import {reactSelectStyle} from "../../reactSelect";
import {Input, RadioGroup, Mapbox, FormField} from '../../../../components/index';
import validator from "./FirstStep.validator";
import propertyTypeOptions from "../../../../asset/data/propertyTypes";
import transactionTypeOptions from "../../../../asset/data/transactionTypes";
import * as regionActions from "../../../../redux/action/region.action";
import * as stateActions from "../../../../redux/action/state.action";
import * as functions  from "../../../../helper/functions";

class FirstStep extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      property: {
        firstName: '',
        lastName: '',
        mobileNumber: '',
        phoneNumber: '',
        propertyType: 'APARTMENT',
        transactionType: 'SELL',
        state: '',
        region: '',
        address: '',
        propertyFloor: '',
        propertyUnit: '',
        lat: '35.711555',
        long: '51.394987'
      },
      validations: {},
      states: [],
      regions: []
    }
  }

  async componentDidMount() {
    await this.fetchStates();
    if (this.state.states && this.state.states.length){
      await this.fetchRegionsByState(this.state.states[0].value);
    }

    this.resetState(this.props.data);
  }

  async resetState(data) {
    const {firstName = '', lastName = '', mobileNumber = '', phoneNumber = '', propertyType = 'APARTMENT', transactionType = 'SELL', state = '', region = '', address = '', propertyFloor = '', propertyUnit = '', long = '51.394987', lat = '35.711555'} = data;
    
    await this.setState({
      property: {firstName, lastName, mobileNumber, phoneNumber, propertyType, transactionType, state, region, address, propertyFloor, propertyUnit, long, lat},
      validations: {},
    });
  }

  async fetchStates(title) {
    const response = await this.props.findStatesByTitle(title);
    await this.setState({states: response.map((item) => {
        return { value: item.id, label: item.title }
      })
    });
  }

  async fetchRegionsByState(state) {
    const response = await this.props.findRegionByState(state);
    await this.setState({regions: response.map((item) => {
        return { value: item.id, label: item.title }
      })
    });
  }

  changeForm(key, value, callback = null) {
    let {property, validations} = this.state;

    this.setState(prevState => (
        {
          property: {...prevState.property, [key]: value},
        }), () => {
      property = this.state.property;
      const validation = validator.validate({ [key]: property[key] });
      this.setState({
        validations: { ...validations, [key]: validation[key] }
      });
      if (callback) {
        callback.bind(this).call();
      }
    });
  }

  submitForm = async () => {
    const { onNext } = this.props;
    const { property } = this.state;

    const validation = validator.validate(property);
    this.setState({validations: validation});

    if (!validation.isValid) {
      functions.errorToast('اطلاعات را به درستی وارد کنید');
      return;
    }

    await onNext(property);
  };

  render() {
    const { states, regions, validations } = this.state;
    const { firstName, lastName, mobileNumber, phoneNumber, propertyType, transactionType, state, region, address, propertyFloor, propertyUnit, lat, long } = this.state.property;
    return (
        <Container>
          <Row className={'mb-2'}>
            <Col>
              <span className={style.form_section_title}>مشخصات مالک</span>
            </Col>
          </Row>
          <Row>
            <Col sm={6} lg={3} className={'mb-3'}>
              <FormField validation={validations.firstName}>
                <Input type={'text'} label={'نام'} placeholder={'نام'} value={firstName} onChange={(value) => {
                  this.changeForm('firstName', value);
                }} />
              </FormField>
            </Col>
            <Col sm={6} lg={3} className={'mb-3'}>
              <FormField validation={validations.lastName}>
                <Input type={'text'} label={'نام خانوادگی'} placeholder={'نام خانوادگی'} value={lastName} onChange={(value) => {
                  this.changeForm('lastName', value);
                }} />
              </FormField>
            </Col>
            <Col sm={6} lg={3} className={'mb-3'}>
              <FormField validation={validations.mobileNumber}>
                <Input type={'text'} label={'تلفن همراه'} placeholder={'تلفن همراه'} value={mobileNumber} onChange={(value) => {
                  this.changeForm('mobileNumber', value);
                }} />
              </FormField>
            </Col>
            <Col sm={6} lg={3} className={'mb-3'}>
              <Input type={'text'} label={'تلفن ثابت'} placeholder={'تلفن ثابت'} value={phoneNumber} onChange={(value) => {
                this.changeForm('phoneNumber', value);
              }} />
            </Col>
          </Row>
          <Row className={'mt-4 mb-2'}>
            <Col>
              <span className={style.form_section_title}>نوع ملک</span>
            </Col>
          </Row>
          <Row>
            <Col>
              <RadioGroup options={propertyTypeOptions} value={propertyType} containerClass={style.radio_container} itemClass={style.radio_item} onChange={(value) => {
                this.changeForm('propertyType', value)
              }} />
            </Col>
          </Row>
          <Row className={'mt-4 mb-2'}>
            <Col>
              <span className={style.form_section_title}>نوع معامله</span>
            </Col>
          </Row>
          <Row>
            <Col>
              <RadioGroup options={transactionTypeOptions} value={transactionType} containerClass={style.radio_container} itemClass={style.radio_item} onChange={(value) => {
                this.changeForm('transactionType', value)
              }} />
            </Col>
          </Row>
          <Row className={'mt-4 mb-2'}>
            <Col>
              <span className={style.form_section_title}>موقعیت ملک</span>
            </Col>
          </Row>
          <Row className={`${style.location_row}`}>
            <Col md={6} xl={'2'} className={'mb-3'}>
              <FormField validation={validations.state}>
                <Select
                    placeholder="استان"
                    className="react-select"
                    closeMenuOnSelect={true}
                    styles={reactSelectStyle}
                    isMulti={false}
                    isClearable={"true"}
                    onChange={(newValue) => {
                      this.changeForm("state", newValue ? newValue.value : '');
                      this.fetchRegionsByState(newValue ? newValue.value : '');
                    }}
                    value={states ? states.filter((opt) => opt.value === state) : ''}
                    options={states}
                />
              </FormField>
            </Col>
            <Col md={6} xl={'2'} className={'mb-3'}>
              <FormField validation={validations.region}>
                <Select
                    placeholder="محله"
                    className="react-select"
                    closeMenuOnSelect={true}
                    styles={reactSelectStyle}
                    isMulti={false}
                    isClearable={"true"}
                    onChange={(newValue) => {
                      this.changeForm("region", newValue ? newValue.value : '');
                    }}
                    value={regions ? regions.filter((opt) => opt.value === region) : ''}
                    options={regions}
                />
              </FormField>
            </Col>
            <Col md={6} xl={6} className={'mb-3'}>
              <Input type={'text'} label={'آدرس'} placeholder={'آدرس'} value={address} onChange={(value) => {
                this.changeForm('address', value);
              }} />
            </Col>
            <Col md={6} xl={1} className={'mb-3'}>
              <Input type={'text'} label={'طبقه'} placeholder={'طبقه'} value={propertyFloor} onChange={(value) => {
                this.changeForm('propertyFloor', value);
              }} />
            </Col>
            <Col md={6} xl={1} className={'mb-3'}>
              <Input type={'text'} label={'واحد'} placeholder={'واحد'} value={propertyUnit} onChange={(value) => {
                this.changeForm('propertyUnit', value);
              }} />
            </Col>
          </Row>
          <Row className={'mt-4 mb-2'}>
            <Col>
              <span className={`${style.form_section_title} ${style.map}`}>موقعیت ملک روی نقشه را انتخاب کنید</span>
            </Col>
          </Row>
          <Row>
            <Col>
              <div className={`${style.map_container}`}>
                <Mapbox centerCoordinator={[long, lat]} onClick={(long, lat) => {
                  this.changeForm('long', long);
                  this.changeForm('lat', lat);
                }} />
              </div>
            </Col>
          </Row>
          <Row className={'mt-3'}>
            <Col>
              <div className={`${style.button_container}`}>
                <button type="button" className={`btn btn-primary btn-sm `} onClick={() => {
                  this.submitForm();
                }}>
                  مرحله بعد
                </button>
              </div>
            </Col>
          </Row>
        </Container>
    );
  }
}

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
  findRegionByState: (state) => dispatch(regionActions.findRegionByState(state)),
  findStatesByTitle: (title) => dispatch(stateActions.findStatesByTitle(title))
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(FirstStep));
